import { getTabTool, patchTask, finalizeTabTool } from '@fno/service/api/tasks.js'
import { getSchool, patchSchool } from '@fno/service/api/schools.js'
import { preFormMutator, getKeypath, preChangeMutator, previousHandler } from '@fno/route/hello/task/helpers.js'
import delay from '@fno/lib/delay.js'
import genericChange from '@fno/lib/form/generic-change.js'
import genericReset from '@fno/lib/form/generic-reset.js'
import tabToolSchema from 'fanx-schema/resource/taskTabTool'
import template from './AllDone.svelte'
import transformApiResponseToFormObject from '@fno/lib/transform-api-response-to-form-object.js'
import setContextOriginal from '@fno/lib/form/set-context-original.js'

const page = {
    clientOnboarding: {
        type: Object,
        schema: tabToolSchema,
        patch: (task) => patchTask({ task })
    }
}

export default (parent, stateRouter) => {
    const name = `${parent}.allDone`

    stateRouter.addState({
        name,
        route: '/allDone',
        template,
        data: {
            title: 'All Done! | T.A.B.'
        },
        resolve: async (ignore, { schoolId }) => {
            const [ clientOnboarding ] = await Promise.all([
                getTabTool({ schoolId })
            ])

            return setContextOriginal(
                {
                    context: {
                        form: {
                            clientOnboarding: transformApiResponseToFormObject({
                                schema: tabToolSchema,
                                data: clientOnboarding
                            })
                        }
                    }
                },
                preFormMutator
            )
        },
        activate: ({ domApi: component, parameters: { schoolId } }) => {
            component.$on('change', genericChange({ component, page, getKeypath, preChangeMutator }))
            component.$on('reset', genericReset({ component }))
            component.$on('previousStepClicked', previousHandler(stateRouter, 'features', schoolId))
            component.$on('nextStepClicked', () => {
                component.$set({ saving: 'Wrapping everything up, one moment...' })
                const taskPromise = getTabTool({ schoolId })
                    .then(task => {
                        task.attributes.status = 'COMPLETED'
                        return patchTask({ task })
                    })
                const schoolPromise = getSchool({ schoolId })
                    .then(school => {
                        school.attributes.onboardingCompletion = Math.round(new Date().getTime() / 1000)
                        return patchSchool({ school })
                    })
                const finalizePromise = finalizeTabTool({ schoolId })
                Promise
                    .all([
                        taskPromise,
                        schoolPromise,
                        finalizePromise
                    ])
                    .then(() => {
                        component.$set({ saving: 'One moment while we redirect you...' })
                        return delay(1000)
                    })
                    .then(() => {
                        window.location = window.location.pathname
                    })
                    .catch(error => {
                        console.error('something unexpected happened!', error) // eslint-disable-line no-console
                    })
            })
        }
    })
}
